import { render, staticRenderFns } from "./ReactionsAndAnswersStep.vue?vue&type=template&id=0b15fb76&scoped=true"
import script from "./ReactionsAndAnswersStep.vue?vue&type=script&lang=ts"
export * from "./ReactionsAndAnswersStep.vue?vue&type=script&lang=ts"
import style0 from "./ReactionsAndAnswersStep.vue?vue&type=style&index=0&id=0b15fb76&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15fb76",
  null
  
)

export default component.exports